<script setup>
import { computed } from 'vue'
import { useSpotStore } from '~/store/spot'

const { t } = useI18n()
const spot = useSpotStore()
const getDirectClass = v => ({ '!text-buy': v > 0, '!text-sell': v < 0 })
const priceText = computed(() => fix(spot.overview?.c, spot.ps))
const dl = computed(() => {
  const { r, rt, high, low, amount, volume } = spot.overview ?? {}
  const { ps, as } = spot.curInfo
  return [
    { key: 'rate', dt: t('24H 涨跌'), dd: rt ?? '--', class: getDirectClass(r) },
    { key: 'high', dt: t('24H 最高价'), dd: fix(high ?? '--', ps) },
    { key: 'low', dt: t('24H 最低价'), dd: fix(low ?? '--', ps) },
    { key: 'amount', dt: `${t('24H 成交量')}(${spot.base})`, dd: fix(volume ?? '--', ps) },
    { key: 'value', dt: `${t('24H 成交额')}(${spot.quote})`, dd: fix(amount ?? '--', as) },
  ]
})
</script>

<template>
  <dl class="flex flex-col justify-center px-4 space-y-1 text-xs leading-4 border-l h-7 border-border">
    <dt
      :class="[getDirectClass(spot.overview.c)]"
      class="text-base font-medium text-textTertiary"
    >
      {{ priceText ?? '--' }}
    </dt>
  </dl>
  <dl v-for="i in dl" :key="i.key" class="flex flex-col text-xs justify-center px-2 space-y-1 leading-4 h-7">
    <dt class="text-textTertiary">
      {{ i.dt }}
    </dt>
    <dd :key="i.key" class="font-medium text-textPrimary" :class="i.class">
      {{ i.dd }}
    </dd>
  </dl>
</template>
